/*!
 * Glance Digital Custom JavaScript Programing
 * lance@glance.ca
 *
 */

jQuery(document).ready(function ($) {
  // SETTINGS
  // ------------------

  // Velocty Easing
  // ------

  $.Velocity.defaults.easing = "easeInOutQuart";

  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  // PLUGINS
  // ------------------

  // Intro State

  if ($(".intro .site-header").length) {
    $(".intro .site-header").introState();
  }

  // Headline animation

  if ($(".restack-headline-mask").length) {
    $(".restack-headline-mask").headline();
  }

  // Hamburger Menu

  if ($(".site-header").length) {
    $(".site-header").mainMenu();
  }

  // Banner Image Parallax (parallax.js)

  $(".parallax-fg").each(function () {
    $(this).parallaxFG({ offsetIntertia: $(this).data("inertia") });
  });

  // Accordion
  if ($(".accordion").length) {
    $(".accordion").accordion();
  }

  // Member expand
  if ($(".module-team__member").length) {
    $(".module-team__member").each(function () {
      $(this).memberExpand();
    });
  }

  // Show in View (inview-animate.js)

  if ($(".showOnView").length) {
    $(".showOnView").showOnView();
  }

  if ($(".showOnViewRight").length) {
    $(".showOnViewRight").showOnView({
      transitionDelay: 150,
      transitionIn: "transition.slideLeftBigIn",
    });
  }
  

  // Ajax Load Posts
  $("#postslist").each(function () {
    $(this).ajaxLoad();
  });

  // Anchor Link Scroll

  $("body").checkForAnchorScrollOnLoad({ offset_lg: 60, offset_sm: 30 });

  // Init Breakpoint Listeners
  // ------------------

  $(this).breakpoints();
});

// ------------------------------------------------------------------------------------------------------------------------------------------------
// PLUGINS

(function ($) {
  // Intro State
  // ------

  $.fn.introState = function (options) {
    var settings = $.extend(
      {
        trigger_offset: 30,
      },
      options
    );

    var $window = $(window);
    var $body = $("body");
    var $skip = this.find(".skip");
    var $intro = this.find(".restack-intro");
    var intro_interval = 600;
    var step = 300;

    setTimeout(function () {
      new_animation();
    }, step / 2);

    function scrollState() {
      if ($window.scrollTop() >= settings.trigger_offset) {
        // Exit intro
        parallaxscrollcheck();
        $body.addClass("intro-end");
        $window.off("scroll.menustate");
        interrupt_animation();
      }
    }

    $window.on("scroll.menustate", scrollState);
    scrollState();

    $skip.on("click", function () {
      parallaxscrollcheck();

      $("html").velocity("scroll", {
        duration: 450,
        offset: settings.trigger_offset,
      });
    });

    var intervals = Array();

    function new_animation() {      
      var $prev = $intro.find(".active");
      if (!$prev.next().length || $("body").hasClass("intro-end")) {
        end_animation();
      }

      if ($prev.next().length) {
        var $next = $("body").hasClass("intro-end")
          ? $intro.find(".mask:last-child")
          : $prev.next();
        intervals.push(
          setTimeout(function () {
            $next.addClass("active");
          }, intro_interval)
        );
        intervals.push(
          setTimeout(function () {
            $next.addClass("step");
            $prev.removeClass("active step");
          }, intro_interval + step)
        );
        intervals.push(
          setTimeout(function () {
            new_animation();
          }, intro_interval + step * 2)
        );
      }
    }

    function interrupt_animation() {
      $.each(intervals, function (i) {
        clearInterval(intervals[i]);
      });
      new_animation();
    }

    function end_animation() {
      $intro.addClass("end");

      setTimeout(function () {
        // Exit intro
        $body.addClass("intro-end");
        $window.off("scroll.menustate");
        parallaxscrollcheck();
      }, intro_interval * 1.5);
    }

    function parallaxscrollcheck() {
      var scrollAnimation = setInterval(function () {
        $.publish("parallaxscrollcheck");
      }, 50);
      setTimeout(function () {
        clearInterval(scrollAnimation);
      }, 450);
    }
  };

  // Headline animation
  // ------

  $.fn.headline = function () {
    var $this = this;
    var $lines = this.find(".restack-line-mask");
    var count = $lines.length;
    var go = false;
    var delay = 100; // $("body").hasClass("intro") ? 600 : 300;

    this.one("inview", function (event, isInView) {
      if (isInView && go) {
        animate();
      } else if (isInView) {
        go = true;
      }
    });

    setTimeout(function () {
      if (go) {
        animate();
      }
      go = true;
    }, delay);

    function animate() {
      var i = 0;
      var interval = setInterval(function () {
        if (i == 0) {
          $this.addClass("active");
        }
        $lines.eq(i).addClass("active");
        i++;
        if (i >= count) {
          clearInterval(interval);
        }
      }, 1300);
    }
  };

  // Main Menu

  $.fn.mainMenu = function () {
    var $primaryDropdown = this.find(".hamburger");
    var $exit = this.find(".site-header__top-nav__exit");
    var $body = $("body");

    $primaryDropdown.on("click", function (e) {
      e.preventDefault();
      if ($body.hasClass("header-open")) {
        $body.removeClass("header-open");
        $primaryDropdown.removeClass("is-active");
      } else {
        $body.addClass("header-open");
        $primaryDropdown.addClass("is-active");
      }
    });

    $exit.on('click', function(e) {
      if ($body.hasClass("header-open")) {
        $body.removeClass("header-open");
        $primaryDropdown.removeClass("is-active");
      }
    });

    return {
      kill: function () {
        $body.removeClass("header-open");
        $primaryDropdown.off("click").removeClass("is-active");
      },
    };
  };

  // Accordion
  // ------

  $.fn.accordion = function () {
    var $container = this;
    var $rows = this.find(".row");

    this.on("click", ".row", function () {
      toggleRow($(this));
    });

    function toggleRow($el) {
      $el.toggleClass("open");
      if ($el.hasClass("open")) {
        $el.find(".body").slideDown(200);
      } else {
        $el.find(".body").slideUp(200);
      }
    }

    function openRow($el) {
      if ($el.hasClass("open")) {
        return false;
      }
      toggleRow($el);
    }

    $.subscribe("scrolltoanchor", function (obj, data) {
      if (data.el.hasClass("row") && data.el.parent()[0] == $container[0]) {
        openRow(data.el);
      }
    });

    this.one("inview", function (event, isInView) {
      if (isInView) {
        $rows.each(function (i, el) {
          setTimeout(function () {
            $(el).addClass("inview");
          }, 200 + 300 * i);
          i++;
        });
      }
    });
  };

  // Member Expand
  // -----

  $.fn.memberExpand = function () {
    var $container = this;
    var $excerpt = this.find(".excerpt");
    var $body = this.find(".body");
    var $close = $body.find(".show-less");

    $excerpt.on("click", function () {
      if (!$container.hasClass("open")) {
        $container.addClass("open");
        $body.slideDown(200);
      }
    });

    $close.on("click", function () {
      if ($container.hasClass("open")) {
        $container.removeClass("open");
        $body.slideUp(200);
      }
    });
  };

  // Ajax Load Posts
  // ------

  $.fn.ajaxLoad = function (options) {
    var settings = $.extend(
      {
        page_action: "posts_load",
        paginate: "#paginateNav",
        template: "parts/loop-archive.php",
        post: ".ajax-post",
        filter: null,
        attr_post_type: "post_type",
        attr_posts_per_page: "posts_per_page",
        attr_orderby: "orderby",
      },
      options
    );
    var $container = this;
    var post_type = $container.data(settings.attr_post_type);
    var posts_per_page = $container.data(settings.attr_posts_per_page);
    var order_by = $container.data(settings.attr_orderby);
    var $paginateNav = $container.next(settings.paginate);
    var pageIsLoading = false;
    var $filter =
      settings.filter && $(settings.filter).length ? $(settings.filter) : false;
    var filter_str = "";

    $paginateNav.bind("inview", function (event, visible, topOrBottomOrBoth) {
      if (visible == true) {
        if ($filter) {
          updateFilter();
        }
        ajaxLoad("paginate");
      }
    });

    if ($filter) {
      $filter.on("click", "button", function () {
        $(this)
          .addClass("selected")
          .parent()
          .siblings()
          .find("button")
          .removeClass("selected");

        updateFilter();
        ajaxLoad("filter");
      });
    }

    function updateFilter() {
      var taxonomy = $filter.data("taxonomy");
      filter_str = "";

      $filter.find("button").each(function () {
        var $a = $(this);
        if ($a.hasClass("selected") && $a.data("filter") != "all") {
          filter_str = taxonomy + ":" + $a.data("filter");
        }
      });
    }

    function ajaxLoad(action) {
      if (!pageIsLoading) {
        pageIsLoading = true;

        $container.addClass("loading " + action);
        $paginateNav.addClass("loading " + action);

        var offset =
          action == "paginate" ? $container.find(settings.post).length : 0;

        var data = {
          action: settings.page_action,
          type: post_type,
          template: settings.template,
          offset: offset,
          postsPerPage: posts_per_page,
          filter: filter_str,
          orderBy: order_by,
        };

        // console.log(data);

        if (action == "filter") {
          $paginateNav.show();
        }

        $.ajax({
          url: glance.ajaxUrl,
          type: "post",
          data: data,
          success: function (result) {
            var $result = $(result);
            var numResults = $result.length;
            var maxPages = $result.first().data("max");
            var hidePaginate =
              numResults < posts_per_page ||
              !(maxPages * posts_per_page > offset + numResults);

            if ($result.find(".showOnView").length) {
              $result.find(".showOnView").css("opacity", 0).showOnView();
            }

            if (action == "paginate") {
              $result.appendTo($container);
            } else {
              $container.html($result);
            }

            if (hidePaginate) $paginateNav.hide();
            pageIsLoading = false;
            $container.removeClass("loading " + action);
            $paginateNav.removeClass("loading " + action);
          },
        });
      }
    }

    return this;
  };

  // Anchor scroll
  // ------

  $.fn.checkForAnchorScrollOnLoad = function (options) {
    var settings = $.extend(
      {
        offset_lg: 0,
        offset_sm: 0,
      },
      options
    );

    var window_href = window.location.href;
    var window_pathname = window.location.pathname;
    var window_hash = window.location.hash;
    var window_id = window_hash.split("#")[1];
    var offset = settings.offset_lg;
    var $body = $("body");
    var $primaryDropdown = this.find(".hamburger");

    $.subscribe("breakpoints", function (obj, media) {
      offset = media.small ? settings.offset_sm : settings.offset_lg;
    });

    scrollToAnchor(window_id);

    $("a").on("click", function (event) {
      var href = $(this).attr("href");
      page = href.split("#")[0];
      var id = href.split("#")[1];

      if (
        id &&
        (page == "" ||
          page == window_pathname ||
          href.indexOf(window_href) > -1)
      ) {
        event.preventDefault();
        scrollToAnchor(id);
        $body.removeClass("header-open");
        $primaryDropdown.removeClass("is-active");
      }
    });

    function scrollToAnchor(id) {
      if ($("#" + id).length) {
        var $el = $("#" + id);
        var top = id == "top" ? $el.offset().top : $el.offset().top - offset;
        $("html").velocity("scroll", { duration: 900, offset: top });
        $.publish("scrolltoanchor", [{ el: $el }]);
      }
    }
  };

  // Utilities
  // ------

  var aboveView = function (element) {
    return (
      $(window).scrollTop() >= element.offset().top + element.outerHeight()
    );
  };

  var belowFocus = function (element, focusMultipliers) {
    return (
      $(window).height() + $(window).scrollTop() <
      element.offset().top + $(window).height() * focusMultipliers
    );
  };

  var isInFocus = function (element, focusMultipliers) {
    return (
      aboveView(element) != true &&
      belowFocus(element, focusMultipliers) != true
    );
  };
})(jQuery);
